import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  id: any;
}

export const useGetKeyHistory = ({ id }: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.KEY_HISTORY, { keyId: id }], {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
    notifyOnChangeProps: [
      "data",
      "error",
      "refetch",
      "isRefetching",
      "isSuccess",
      "isLoading",
    ],
  });
};
